export default __webpack_public_path__ + "static/allen-6f39a3fa97f17e6e19b7b3758eee7c52.png";